import { createClient } from '@supabase/supabase-js';

/**
 * Cliente de Supabase configurado
 * Las variables de entorno necesarias son:
 * - REACT_APP_SUPABASE_URL: URL del proyecto Supabase
 * - REACT_APP_SUPABASE_ANON_KEY: Clave anónima de Supabase
 */

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn('Variables de entorno de Supabase no configuradas');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
